export enum ClientEnum {
  hackatao = "hackatao",
  nftstudios = "nftstudios",
  reisinger = "reisinger",
  whaleshark = "whaleshark",
}
